'use strict';

var PropTypes = require('prop-types');
/**
 * Created by jlitt04 on 07/19/2017.
 */

var React = require('react');
var createReactClass = require('create-react-class');
var LocalizeMixin = require("../../localization/CommonLocalizationMixin");
var PageTitle = require('../pageTitle.js').default;
var UpdatePostalCodeComponent = require('./updatePostalCode.js');

module.exports = createReactClass({
    displayName: 'exports',

    mixins: [LocalizeMixin],
    propTypes: {
        isLoyaltyIntent: PropTypes.bool,
        removeMessageFromProps: PropTypes.func,
        submitHandler: PropTypes.func.isRequired
    },
    componentDidMount: function componentDidMount() {
        document.querySelector('#page-title').focus();
    },
    onSubmit: function onSubmit(params) {
        if (this.props.submitHandler) {
            this.props.submitHandler(params);
        }
    },
    spliceError: function spliceError(idx) {
        if (this.props.removeErrorClick) {
            this.props.removeErrorClick(idx);
        }
    },
    removeMessageFromProps: function removeMessageFromProps(idx) {
        if (this.props.removeMessageFromProps) {
            this.props.removeMessageFromProps(idx);
        }
    },
    render: function render() {
        var that = this;
        //TODO: this page will have a different sub title than social sign up
        var subTitle = this.getLocalizedText('email_sign_up_need_postal');

        var errors = this.props.errors && this.props.errors.length > 0 ? React.createElement(
            'div',
            { ref: 'errorAlert', className: 'row' },
            React.createElement(
                'div',
                { className: 'col-xs-12 errors' },
                this.props.errors.map(function (error, idx) {
                    return React.createElement(
                        'p',
                        { className: 'bg-danger alert-danger alert' },
                        error,
                        React.createElement(
                            'span',
                            { onClick: that.spliceError.bind(that, idx), className: 'close', 'aria-hidden': 'true' },
                            '\xD7'
                        )
                    );
                })
            )
        ) : [];

        var messages = [];
        if (this.props.messages && this.props.messages.length) {
            this.props.messages.forEach(function (message, idx) {
                messages.push(React.createElement(
                    'p',
                    { key: "message-prop" + idx, className: 'bg-success alert-success alert' },
                    message,
                    React.createElement(
                        'span',
                        { className: 'close', onClick: that.removeMessageFromProps.bind(that, idx) },
                        '\xD7'
                    )
                ));
            });
        }

        return React.createElement(
            'div',
            null,
            React.createElement(
                'div',
                { className: 'sign-up-container social' },
                React.createElement(
                    'div',
                    { className: 'container' },
                    React.createElement(
                        'div',
                        {
                            className: 'col-xs-12 col-sm-6 col-sm-offset-3 col-md-5 col-md-offset-4 col-lg-4 col-lg-offset-4' },
                        React.createElement(PageTitle, { titleText: this.getLocalizedText('email_sign_up_page_title') }),
                        React.createElement(
                            'div',
                            { 'aria-live': 'polite' },
                            errors,
                            messages
                        ),
                        React.createElement(UpdatePostalCodeComponent, {
                            cntry: this.props.cntry,
                            lang: this.props.lang,
                            handleSubmit: this.onSubmit,
                            submitButtonText: this.getLocalizedText("common_login_submit_button"),
                            postalCode: this.props.postalCode,
                            requireTerms: false,
                            subTitle: subTitle,
                            handleSkipButtonClick: this.props.handleSkipButtonClick
                        })
                    )
                )
            )
        );
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/loginComponents/postalCodePage.js
// module id = 734
// module chunks = 0